<template>
  <div class="content">
    <div class="filter">
      <el-date-picker v-model="registerDate" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']" @change="handleDatePick"></el-date-picker>
      <el-select v-model="listParams.status" placeholder="全部类型" @change="initPage" clearable>
        <el-option label="待提交" :value="0"></el-option>
        <el-option label="审批中" :value="1"></el-option>
        <el-option label="待充值" :value="2"></el-option>
        <el-option label="已完成" :value="3"></el-option>
        <el-option label="已撤销" :value="4"></el-option>
      </el-select>
      <el-input placeholder="请输入关键字(英文逗号分隔)" v-model.trim="text" class="input-with-select" style="width:400px" @change="handleSearh" clearable @clear="handleClear">
        <el-select v-model="listParams.queryType" slot="prepend" placeholder="请选择" @change="initPage" style="width:130px">
          <el-option label="邮箱/手机号" value="0"></el-option>
          <el-option label="创建人" value="1"></el-option>
          <el-option label="提出人" value="2"></el-option>
        </el-select>
      </el-input>
      <el-button @click="visible=true" style="margin-left:15px">创建充值</el-button>
    </div>

    <el-table :data="list" height="calc(100vh - 198px)">
      <el-table-column type="index" label="序号" width="80"></el-table-column>
      <el-table-column label="邮箱/手机号" :show-overflow-tooltip="true" min-width="300">
        <template slot-scope="{row}">
          
          <el-popover placement="bottom-start" width="350" trigger="click" title="邮箱/手机号">
            <div v-for="(item,index) in row.emails" :key="index" class="f-b-c" style="margin-bottom:3px"><span>{{item.email}}</span>/ <span>{{item.phone}}</span></div>
            <!-- <span class="pointer" slot="reference">邮箱: {{row.emails[0].email}} <br> <span>充值金额: {{row.emails[0].rechargeAmount}} USD</span> <i v-show="row.emails.length>1" style="color:#99c41c">>></i> </span> -->
            <span class="pointer" slot="reference">{{row.emails[0].email}} {{ row.emails[0].email && row.emails[0].phone ? '/' : '' }} {{row.emails[0].phone}}</span>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="充值金额" :show-overflow-tooltip="true" min-width="300">
        <template slot-scope="{row}">
          <el-popover placement="bottom-start" width="350" trigger="click" title="充值金额">
            <div v-for="(item,index) in row.emails" :key="index" class="f-b-c" style="margin-bottom:3px"><span>{{item.rechargeAmount}} USD</span></div>
            <span class="pointer" slot="reference">{{row.emails[0].rechargeAmount}} USD</span>
            
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="reason" label="充值原因" min-width="150"></el-table-column>
      <el-table-column prop="createDate" label="时间信息" min-width="200">
        <template slot-scope="{row}">
          <span>创建时间：{{row.createDate}}</span><br>
          <span v-if="row.rechargeDate">充值时间：{{row.rechargeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="modifyDate" label="人员信息" min-width="200">
        <template slot-scope="{row}">
          <span>提出人：{{row.proposerName}}</span><br>
          <span>创建人：{{row.createrName}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="statusName" label="需求状态" min-width="150" :show-overflow-tooltip="true">
        <template slot-scope="{row}">
          <span>{{row.statusName}}</span><br>
          <span v-if="row.statusName==='已完成'">{{row.approvalNumber}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" :show-overflow-tooltip="true" min-width="150"></el-table-column>
      <el-table-column label="操作" width="180">
        <template slot-scope="{row}">
          <el-button type="text" size="medium" @click="seeDetail(row.id)" style="margin-right:15px">查看</el-button>
          <el-button type="text" size="medium" v-if="row.status===0" @click="submitRecharge(row.id)" style="margin-right:15px">提交</el-button>
          <el-button type="text" size="medium" v-if="row.status===1" @click="revokeRecharge(row.id)" style="margin-right:15px">撤销</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="f-b-c bg-white" style="padding: 10px">
      <div></div>
      <el-pagination background :current-page="listParams.pageNumber" :page-sizes="[20, 50, 100, 200, 500]" :page-size="listParams.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" class="el-pagination" @size-change="sizeChange" @current-change="pageChange" />
    </div>
    <el-dialog title="新增" :visible.sync="visible" width="800px" :before-close="resetPage" :close-on-click-modal="false">
      <el-form ref="rechargeForm" :model="rechargeForm" label-width="120px" :rules="baseRules">
        <el-form-item label="邮箱/手机号:" prop="rechargeEmails">
          <div v-for="(item,index) in rechargeForm.rechargeEmails" :key="index" style="margin-bottom:5px;">
            <el-select v-model="item.email" size="medium" filterable remote reserve-keyword placeholder="请选择邮箱/手机号" :remote-method="remoteMethod" style="width:400px;margin-right:15px" :loading="selectLoading" @change="value=>emailRegisterInfo(value,item)">
              <!-- <el-option v-for="item in userOptions" :key="item.userId" :label="item.email" :value="item.email" /> -->
              <el-option v-for="item in userOptions" :key="item.userId" :label="item.showName" :value="item.showName"/>
            </el-select>
            <!-- <el-input v-model="item.email" style="width:400px;margin-right:15px" :min="0" placeholder="请输入一条正确的邮箱地址" @blur="emailRegisterInfo"></el-input> -->
            <el-input-number placeholder="USD" :precision="2" controls-position="right" style="margin-right:15px" v-model="item.rechargeAmount" :min="0"></el-input-number>
            <!-- <span>USD</span> -->
            <i class="el-icon-remove pointer" @click="deleteRow(index)" style="color:#99c41c;font-size:20px;" v-show="rechargeForm.rechargeEmails.length>1"></i>
            <i class="el-icon-circle-plus pointer" @click="addRow" style="color:red;font-size:20px;" v-show="rechargeForm.rechargeEmails.length<=100&&index===rechargeForm.rechargeEmails.length-1"></i>
          </div>
        </el-form-item>
        <el-form-item label="提出人:" prop="proposerName">
          <el-select v-model="rechargeForm.proposerName" placeholder="提出人" clearable>
            <el-option v-for="(item,index) in proposer" :key="index" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="充值金额:" prop="rechargeAmount">
          <el-input-number :precision="2" v-model="rechargeForm.rechargeAmount" :min="0"></el-input-number><span>USD</span>
        </el-form-item> -->
        <el-form-item label="充值原因:" prop="reason">
          <el-input type="textarea" :rows="4" maxlength="250" show-word-limit :autosize="{ minRows: 2, maxRows: 6 }" v-model="rechargeForm.reason"></el-input>
        </el-form-item>
        <el-form-item label="备注:" prop="remark">
          <el-input type="textarea" :rows="4" maxlength="250" show-word-limit :autosize="{ minRows: 2, maxRows: 6 }" v-model="rechargeForm.remark"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer" v-if="!isShow">
        <el-button :loading="loading" @click="resetPage">取 消</el-button>
        <el-button :loading="loading" type="primary" @click="setRecharge(0)">保存</el-button>
        <el-button :loading="loading" type="primary" @click="setRecharge(1)">保存并提交</el-button>
      </span>
    </el-dialog>
    <el-dialog title="详情" :visible.sync="detailVisible" width="800px" :before-close="resetPage" :close-on-click-modal="false">
      <el-form ref="rechargeForm" :model="rechargeForm" label-width="100px" :rules="baseRules">
        <el-form-item label="邮箱/手机号:" prop="">
          <div v-for="(item,index) in rechargeDetail.rechargeJson" :key="index">
            <span>{{item.email}}</span>
            <span>{{item.phone}}</span>
            <span style="display:inline-block;margin-left:5px">{{item.rechargeAmount}}USD</span>
          </div>
        </el-form-item>
        <el-form-item label="提出人:" prop="">
          <span>{{rechargeDetail.proposerName}}</span>
        </el-form-item>
        <el-form-item label="充值原因:" prop="">
          <span>{{rechargeDetail.reason}}</span>
        </el-form-item>
        <el-form-item label="备注:" prop="remark">
          <span>{{rechargeDetail.remark}}</span>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api'
import _ from 'lodash'
import { dateFormat } from '@/utils/date'
export default {
  name: 'operation_recharge',
  data() {
    return {
      registerDate: [],
      visible: false,
      isShow: false,
      detailVisible: false,
      selectLoading: false,
      text: '',
      total: 0,
      listParams: {
        pageNumber: 1,
        pageSize: 20,
        queryType: '0',
      },
      rechargeForm: {
        rechargeEmails: [{ email: '', rechargeAmount: undefined }]
      },
      rechargeDetail: {},
      roleForm: {
        roleList: [10]
      },
      loading:false,
      proposer: [],
      spuForm: {},
      commodityForm: {},
      currentFilter: 'productName',
      list: [],//列表
      userOptions: [],//列表
      userParameter: {
        email: undefined, // 查询关键字
        pageNumber: 1,
        pageSize: 20,
      },
      allRegister: false,
      baseRules: {
        rechargeEmails: [{ required: true, message: '请输入邮箱/手机号', trigger: 'blur' },],
        rechargeAmount: [{ required: true, message: '请输入充值金额', trigger: 'blur' },],
        reason: [{ required: true, message: '请输入充值原因', trigger: 'blur' },],
        proposerName: [{ required: true, message: '请选择提交人', trigger: 'change' },]
      }
    }
  },
  created() {
    this.getRechargeList()
    this.getProposer()
    this.getUserOptions()

    this.isSuperAdministrator = this.$store.getters.userRole == 4
  },
  computed: {
    getStatus() {
      return (statu) => {
        switch (statu) {
          case 1:
            return '未接收'
          case 2:
            return '已接收'
          case 3:
            return '已完成'
          case 4:
            return '已取消'
          case 5:
            return '已上架'
        }
      }
    },
    getPaymentStatus() {
      return (statu) => {
        switch (statu) {
          case 0:
            return '-'
          case 1:
            return '未支付'
          case 2:
            return '已支付'
        }
      }
    }
  },
  methods: {
    async getUserOptions() {
      this.selectLoading = true
      let result = await API.getUserOptions(this.userParameter)
      this.userOptions = result.data.list
      this.selectLoading = false
    },
    remoteMethod(query) {
      if (query) {
        this.userParameter.email = query
      } else {
        this.userParameter.email = undefined
      }
      this.getUserOptions()
    },
    //确认发起收款
    setRecharge(val) {
      this.$refs.rechargeForm.validate((valid) => {
        if (!valid) return
        let allRegister = this.rechargeForm.rechargeEmails.every(item => item.allRegister)
        if (!allRegister) return this.$message.error('未填写邮箱/手机号验证或验证未通过,请重新验证邮箱/手机号.')
        let rechargeForm = _.cloneDeep(this.rechargeForm)
        rechargeForm.proposer = this.proposer.filter(item => { return item.name === this.rechargeForm.proposerName })[0].code
        rechargeForm.isSubmit = val
        let arr = rechargeForm.rechargeEmails.filter(item => item.email !== '').filter(item => !item.rechargeAmount || item.rechargeAmount === undefined)
        if (arr.length > 0) return this.$message.warning('请填写完整充值邮箱/手机号与充值金额信息')
        this.loading=true
        API.setRecharge(rechargeForm).then(res => {
          this.loading=false
          if (res.code !== 10000) return this.$message.error(res.message)
          this.$message.success('创建成功')
          this.getRechargeList()
          this.resetPage()
        }).catch(e=>{
          this.$message.error(e.message)
          this.loading=false
        })
      })
    },

    deleteRow(index) {
      this.rechargeForm.rechargeEmails.splice(index, 1)
    },
    addRow() {
      this.rechargeForm.rechargeEmails.push({ email: '', rechargeAmount: undefined })
    },

    async getProposer() {
      let { data } = await API.getPublicSelectData({ type: 9, param: undefined })
      this.proposer = data
    },

    //详情
    seeDetail(id) {
      this.detailVisible = true
      API.getRechargeDetail(id).then(res => {
        this.rechargeDetail = res.data.data
        this.rechargeDetail.rechargeJson = JSON.parse(this.rechargeDetail.rechargeJson)
      })
    },
    emailRegisterInfo(e, data) {
      let arr = _.cloneDeep(this.rechargeForm.rechargeEmails).filter(item => item.email === e)
      if (arr.length > 1) {
        this.$set(data, 'email', '')
        return this.$message.warning('请勿填写重复邮箱/手机号')
      }
      let emailList = _.uniq(e.split(',').map(item => item.trim()))
      API.emailRegisterInfo(emailList).then(res => {
        if (res.code !== 10000) {
          this.$message.error(res.message)
          this.$set(data, 'email', '')
          return
        }
        if (!res.data.length) {
          this.$message.error(`邮箱/手机号${e}验证错误,请重新选择`)
          this.$set(data, 'email', '')
          return
        }
        this.$set(data, 'allRegister', true)
        this.$message.success('邮箱/手机号验证成功.')
      })
    },
    getRechargeList() {
      API.getRechargeList(this.listParams).then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        this.list = res.data.list
        this.total = res.data.total
        this.list.forEach(item => {
          item.rechargeDate = item.rechargeDate ? dateFormat(item.rechargeDate) : undefined
          item.createDate = dateFormat(item.createDate)
          item.emails = JSON.parse(item.rechargeJson)
        })
      })
    },

    revokeRecharge(id) {
      this.$confirm('确定要撤销充值吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        API.revokeRecharge(id).then(res => {
          if (res.code !== 10000) return this.$message.error(res.message)
          this.$message.success('撤销充值成功.')
          this.getRechargeList()
        })
      })
    },

    submitRecharge(id) {
      this.$confirm('确定要提交审批吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        API.submitRecharge(id).then(res => {
          if (res.code !== 10000) return this.$message.error(res.message)
          this.$message.success('提交审批成功.')
          this.getRechargeList()
        })
      })
    },


    resetPage() {
      this.rechargeForm = {
        rechargeEmails: [{ email: '', rechargeAmount: undefined }]
      },
        this.rechargeDetail = {}
      this.$refs['rechargeForm'].resetFields();
      this.visible = false
      this.detailVisible = false
      this.loading=false
    },
    handleClear() {
      this.listParams.text = undefined
      this.initPage()
    },

    handleSearh() {
      this.listParams.text = this.text.split(',').filter(item => item !== '')
      this.initPage()
    },


    //发起收款
    handlePaymentOpen(row) {
      this.paymentVisible = true
      let { id, userId, userName } = row
      this.sampleFeeForm = { id, userId, userName, operationType: 2, }
    },

    //切换筛选条件
    // handleChange(value) {
    //   this.currentFilter = value
    //   this.input = ''
    //   this.initPage()
    // },

    initPage() {
      this.listParams.pageNumber = 1
      this.getRechargeList()
    },

    //时间筛选
    handleDatePick(value) {
      if (value && value.length === 2) {
        this.listParams.startDate = value[0]
        this.listParams.endDate = value[1]
      } else {
        this.listParams.startDate = undefined
        this.listParams.endDate = undefined
      }
      this.initPage()
    },
    sizeChange(size) {
      this.listParams.pageSize = size
      this.getRechargeList()
    },
    pageChange(page) {
      this.listParams.pageNumber = page
      this.getRechargeList()
    },

  }
}
</script>

<style lang="scss" scoped>
.content {
  height: 100%;
  background: #ffffff;
  padding: 12px 12px 0;
  .filter {
    padding: 12px;
    & > div {
      margin-left: 12px;
    }
    /deep/.el-input-group {
      width: 300px;
    }
    /deep/.el-input-group__prepend {
      width: 100px;
    }
  }
}
.range-num {
  display: inline-block;
  margin-right: 16px;
}
.update-time {
  display: inline-block;
  margin: 0 16px;
}

.avatar {
  width: 178px;
  height: 178px;
  object-fit: cover;
}
.uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
}
/deep/.el-range-separator {
  min-width: 20px;
}
</style>>
